/** Customer booking history helpers (Phase M). */

const CASE_TYPE_LABELS = {
  critical: 'Critical',
  non_critical: 'Non-critical',
};

export function bookingStatusLabel(booking) {
  if (!booking) return '';
  const status = booking.status;
  const travel = booking.travel_status;
  const settlement = booking.settlement_status;

  if (status === 'payment_pending') return 'Payment Pending';
  if (status === 'cancelled') return 'Cancelled';
  if (status === 'completed') return 'Completed';
  if (status === 'in_progress') {
    if (settlement === 'payment_required') return 'Extra Payment Required';
    if (settlement === 'payment_paid') return 'Payment Received';
    if (settlement === 'ready_to_complete') return 'Awaiting Completion';
    return 'Service in Progress';
  }
  if (status === 'confirmed') {
    if (travel === 'en_route') return 'Provider On the Way';
    if (travel === 'arrived') return 'Provider Arrived';
    return 'Confirmed';
  }
  return status?.replace(/_/g, ' ') || 'Unknown';
}

export function caseTypeDisplay(requirements) {
  if (!requirements?.case_type) return null;
  return CASE_TYPE_LABELS[requirements.case_type] || requirements.case_type;
}

export function durationDisplay(booking) {
  const req = booking?.booking_requirements;
  if (req?.duration_label) return req.duration_label;
  const quote = booking?.quote;
  if (quote?.duration_label) return quote.duration_label;
  return null;
}

export function formatBookingDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function historySectionTabs() {
  return [
    { key: 'active', label: 'Active' },
    { key: 'upcoming', label: 'Upcoming' },
    { key: 'completed', label: 'Completed' },
    { key: 'cancelled', label: 'Cancelled' },
  ];
}

export function emptyStateMessage(section) {
  const map = {
    active: 'No active bookings',
    upcoming: 'No upcoming bookings',
    completed: 'No completed bookings',
    cancelled: 'No cancelled bookings',
  };
  return map[section] || 'No bookings';
}

export function primaryDisplayAmount(booking) {
  const amounts = booking?.amounts || {};
  if (booking?.status === 'completed' && amounts.final_amount_paid != null) {
    return amounts.final_amount_paid;
  }
  if (amounts.base_customer_total != null) return amounts.base_customer_total;
  return booking?.quote?.customer_total;
}
